import React, {Component} from 'react';
import {roundigFormat} from '../libs/utils/Operations';
import moment from 'moment';
import '../css/dataTables.css';
import { CURRENCY } from '../libs/utils/Const';

const formatNumber = {
    separador: ',', // separador para los miles
    sepDecimal: '.', // separador para los decimales
    formatear: function (num) {
        num += '';
        let splitStr = num.split('.');
        let splitLeft = splitStr[0];
        let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        let regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },
    new: function (num, simbol) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0;
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(2));
    },
};

const handleSelectChange = (index, field, event, refreshData) => {
    refreshData(index, field, event.target.value)
};

const renderTableBody = (headers, data, action, checkbox, refreshData, openWhsModal) => {
    let body= "";
    const orderTypeOptions = [{key:'P',value:"Pedido"},/*{key:'Q',value:"Oferta de compra"},*/{key:'R',value:"Solicitud de compra"},{key:'T',value:"Solicitud de traslado"},{key:'W',value:"Orden de fabricación"}]
    body = data.map((register, index) => {
        return (
            <tr key={index}>
                <td style={{textAlign:"center", width:100}}>
                    <input type="checkbox" style={{minWidth: '100%'}} id="cbox2" checked={!!checkbox.data.get(index)} disabled={ register.selected || false}
                        onChange={() => checkbox.selectOne(index)}/>
                </td>
                <td style={{textAlign:"center"}}>
                    <select value={register.OrderType} onChange={(event) => handleSelectChange(index, "OrderType", event, refreshData)}>
                        {orderTypeOptions.map((option, idx) => (
                            <option key={option.key} value={option.key}>{option.value}</option>
                        ))}
                    </select>
                </td>
                <td style={{textAlign:"center"}}>{register.ItemName}</td>
                <td style={{textAlign:"center"}}>{Number(register.Quantity).toFixed(2) || ""}</td>
                <td style={{textAlign:"center"}}>{moment(register.ReleasDate).format('DD-MM-YYYY')|| ''}</td>
                <td style={{textAlign:"center"}}>{moment(register.DueDate).format('DD-MM-YYYY') || ''}</td>
                <td style={{textAlign:"center"}}>{register.CardCode || ''}</td>
                <td style={{textAlign:"center"}}>{register.CardName || ''}</td>
                <td style={{textAlign:"center"}}>
                    {register.OrderType === "T" ?
                        <div className="input-group">
                            <input type="text" className="form-control" id="txtPartner" disabled = {true} value={register.FromWhse || ''} />
                            <div className="input-group-prepend">
                                <button
                                    className="btn btn-outline-warning rounded-right"
                                    onClick={() => openWhsModal(index, 1)}>
                                    <i className="fa fa-list" aria-hidden="true" />
                                </button>
                            </div>
                        </div>
                        :
                        (register.FromWhse || '')
                    }
                </td>
                <td style={{textAlign:"center"}}>
                    <div className="input-group">
                        <input type="text" className="form-control" id="txtPartner" disabled = {true} value={register.Warehouse || ''} />
                        <div className="input-group-prepend">
                            <button
                                className="btn btn-outline-warning rounded-right"
                                onClick={() => openWhsModal(index, 2)}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        </div>
                    </div>
                </td>
            </tr>
        )
    })

    return body;
};

const renderTable = (headers, data, action, checkbox, refreshData, openWhsModal) => {
    let header = "";
    let body = "";

    if (headers.length) {
        header = <tr>
            <td className="sticky-header table-header-yellow ">
                <input type="checkbox" style={{minWidth: '100%'}}
                    onChange={(event) => checkbox.selectAll(event.target.checked)}/>
            </td>
            <td className="sticky-header table-header-yellow " style={{textAlign:"center"}}>{headers[0].title}</td>
            <td className="sticky-header table-header-yellow " style={{textAlign:"center"}}>{headers[1].title}</td>
            <td className="sticky-header table-header-yellow " style={{textAlign:"center"}}>{headers[2].title}</td>
            <td className="sticky-header table-header-yellow " style={{textAlign:"center"}}>{headers[3].title}</td>
            <td className="sticky-header table-header-yellow " style={{textAlign:"center"}}>{headers[4].title}</td>
            <td className="sticky-header table-header-yellow " style={{textAlign:"center"}}>{headers[5].title}</td>
            <td className="sticky-header table-header-yellow " style={{textAlign:"center"}}>{headers[6].title}</td>
            <td className="sticky-header table-header-yellow " style={{textAlign:"center"}}>{headers[7].title}</td>
            <td className="sticky-header table-header-yellow " style={{textAlign:"center"}}>{headers[8].title}</td>
        </tr>;
    }

    body = renderTableBody(headers, data, action, checkbox, refreshData, openWhsModal);

    let table = "";

    table =
        <div className="table-wrapper-scroll-y my-custom-scrollbar">
            <table id="dataTableCreate" className="display" style={{width: '100%'}}>
                <thead className="table-header">
                {header}
                </thead>
                <tbody>
                {body}
                </tbody>
            </table>
        </div>;

    return table;

};

export const renderOrderRecommendationModal = (headers, data, action, checkbox, refreshData, openWhsModal) => {

    return renderTable(headers, data, action, checkbox, refreshData, openWhsModal);

}

